import { Tag } from 'antd';
import { FC, memo } from 'react';

import { AppTable } from '@/common/components';

import { DomainVisitors } from '@/modules/Domains';
import { Redirect, getRedirectMatchModeLabel, getRedirectSourceLabel, getRedirectTargetLabel } from '@/modules/Sites/Redirects';

interface Props {
  list: Redirect[];
  totalCount: number;
  currentPage: number;
  itemsPerPage: number;
  isFetching: boolean;
  selectedIds: string[];
  disabled?: boolean;
  onChangePage: (page: number) => void;
  onChangeSelectedIds: (ids: string[]) => void;
}

const getVisitorLabel = (forVisitor: DomainVisitors): string => {
  if (forVisitor === DomainVisitors.Any) return 'Будь-хто';
  if (forVisitor === DomainVisitors.GoogleBot) return 'Google Bot';
  if (forVisitor === DomainVisitors.Person) return 'Людина';

  return forVisitor;
};

export const RedirectsManageTable: FC<Props> = memo(({
  list,
  totalCount,
  currentPage,
  itemsPerPage,
  onChangePage,
  isFetching,
  selectedIds,
  onChangeSelectedIds,
  disabled,
}) => {
  return (
    <AppTable
      rowKey="id"
      size="small"
      loading={ isFetching }
      dataSource={ list }
      rowSelection={{
        selectedRowKeys: selectedIds,
        onChange: (keys) => onChangeSelectedIds(keys as string[]),
        getCheckboxProps: () => ({ disabled }),
      }}
      pagination={{
        current: currentPage,
        pageSize: itemsPerPage,
        total: totalCount,
        onChange: onChangePage,
        hideOnSinglePage: true,
      }}
      columns={ [
        { title: 'З', key: 'source', ellipsis: true, render: (_, redirect: Redirect) => getRedirectSourceLabel(redirect) },
        { title: 'До', key: 'target', ellipsis: true, render: (_, redirect: Redirect) => getRedirectTargetLabel(redirect) },
        {
          title: 'Код',
          dataIndex: 'statusCode',
          width: 90,
          render: (statusCode: Redirect['statusCode']) => <Tag color="blue">{ statusCode }</Tag>,
        },
        {
          title: 'Режим',
          dataIndex: 'matchMode',
          width: 130,
          render: (matchMode: Redirect['matchMode']) => <Tag color="purple">{ getRedirectMatchModeLabel(matchMode) }</Tag>,
        },
        {
          title: 'Відвідувач',
          dataIndex: 'forVisitor',
          width: 130,
          render: (forVisitor: DomainVisitors) => <Tag>{ getVisitorLabel(forVisitor) }</Tag>,
        },
        {
          title: 'Стан',
          dataIndex: 'isActive',
          width: 120,
          render: (isActive: boolean) =>
            isActive ? <Tag color="green">Активний</Tag> : <Tag color="red">Вимкнений</Tag>,
        },
      ] }
    />
  );
});
